"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.debounce = void 0;
/**
 * Debounce is a utility function that will delay the execution of a function,
 * and disregard any other calls to the function until the delay has passed.
 *
 * @param func - function to be debounced
 * @param delay - time in ms to wait before calling the function and disregard any other calls
 * @returns
 */
function debounce(func, delay) {
    let timeoutId;
    return (...args) => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
            func(...args);
        }, delay);
    };
}
exports.debounce = debounce;
//# sourceMappingURL=debounce.js.map